import {
    createSelector
} from 'reselect';

export const getAdminUsersPage = state => state.users.page;
export const getAdminUsersFilterByType = state => state.users.filterByType;
export const getAdminUsersFilterBySearch = state => state.users.filterBySearch;
export const getAdminUsersList = state => state.users.users;
export const getAdminUsersTotal = state => state.users.usersTotal;
export const getAdminUsersAreLoading = state => state.users.loading;
export const getAdminUsersLoadingError = state => state.users.loadingError;



// WEBPACK FOOTER //
// ./app/web/src/selectors/adminUsersSelectors.js